import { DefaultSchoolYear, FilterKeys, GetAttendanceRegistersQueryFilters } from '@schooly/api';
import { DateRangeDropdown, FiltersContainer } from '@schooly/components/filters';
import { FC, useCallback, useState } from 'react';

import { useAttendanceFilters } from './useAttendanceFilters';

type AttendanceFiltersProps = {
  schoolId: string;
  filters: GetAttendanceRegistersQueryFilters;
  notActualInitialDate?: boolean;
  defaultSchoolYear?: DefaultSchoolYear;
  onSetFilters: (v: GetAttendanceRegistersQueryFilters) => void;
};

export const AttendanceFilters: FC<AttendanceFiltersProps> = ({
  filters,
  schoolId,
  notActualInitialDate,
  defaultSchoolYear,
  onSetFilters,
}) => {
  const [dateChanged, setDateChanged] = useState(false);

  const { labels, filtersDate, onSetDate } = useAttendanceFilters({
    filters,
    onSetFilters,
  });

  const handleSetDate = useCallback(
    (v: [Date, Date]) => {
      setDateChanged(true);
      onSetDate(v);
    },
    [onSetDate],
  );

  return (
    <FiltersContainer>
      {filtersDate && (
        <DateRangeDropdown
          schoolId={schoolId}
          date={filtersDate}
          dateChanged={dateChanged}
          onSetDate={handleSetDate}
          notActualInitialDate={notActualInitialDate}
          openLabel={labels[FilterKeys.Date]}
          defaultSchoolYear={defaultSchoolYear}
          schoolYearToToday
        />
      )}
    </FiltersContainer>
  );
};
